// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-line .el-input{width:88px;margin-right:2px}.form-line .el-input .el-input-group__append{width:30px;padding:0;text-align:center;border:none;color:#fff;background-color:transparent}.form-line .input-line{width:260px}.location-div .form-bottom{text-align:center}.location-div .el-switch__label,.location-div .text{color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
